import apiClient from './client'

export interface ContactResponse {
  email: string
  businessName: string
  responseTime: string
  governingLaw: string
}

/**
 * Compliance API module to fetch Markdown legal pages and configuration details
 * from the backend services.
 */
export const complianceApi = {
  /** Get the Privacy Policy in Markdown format */
  getPrivacyPolicy: async (): Promise<string> => {
    const { data } = await apiClient.get<string>('/api/v1/compliance/privacy', {
      headers: { Accept: 'text/markdown' },
      responseType: 'text',
    })
    return data
  },

  /** Get the Terms of Service in Markdown format */
  getTermsOfService: async (): Promise<string> => {
    const { data } = await apiClient.get<string>('/api/v1/compliance/terms', {
      headers: { Accept: 'text/markdown' },
      responseType: 'text',
    })
    return data
  },

  /** Get the User Data Deletion Instructions in Markdown format */
  getDataDeletionInstructions: async (): Promise<string> => {
    const { data } = await apiClient.get<string>('/api/v1/compliance/data-deletion', {
      headers: { Accept: 'text/markdown' },
      responseType: 'text',
    })
    return data
  },

  /** Get the dynamic contact configuration values */
  getContactInfo: async (): Promise<ContactResponse> => {
    const { data } = await apiClient.get<ContactResponse>('/api/v1/compliance/contact')
    return data
  },
}
